import { render, staticRenderFns } from "./avatars.vue?vue&type=template&id=652f50d8"
import script from "./avatars.vue?vue&type=script&lang=js"
export * from "./avatars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports